<template>
  <div>
    <Modal
      v-model="preLookModal"
      width="550"
      title="预览"
    >
      <div style="margin-top:10px;">
        <span>领取短链接：{{ copyUrl }}</span>
        <Button @click="copy">
          复制
        </Button>
        <Button
          @click="copyLong"
          style="padding:0 11px"
        >
          复制长链接
        </Button>
        <p>
          <span>领取二维码:
            <a
              :href="codeUrl"
              download
            >下载二维码</a>
          </span>
        </p>
        <p style="background:yellow;padding:5px 0;margin-top:5px;">
          扫一扫查看，推荐使用支付宝、微信、手机浏览器 {{ codeTxt }}
        </p>
        <center
          id="target"
          style="margin-top:20px;"
        >
          <qrcode
            :value="qrcodeUrl"
            :options="{ size: 170 }"
          >
          </qrcode>
        </center>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import QRcode from '@xkeshi/vue-qrcode';
import { getQrcodeInfo } from '../../api/electronicInvoice';
import { copyText } from '../../utils/tools';
// import Curl from '@/common/config';


export default {
  components: {
    qrcode: QRcode,
  },
  props: ['codeTxt'],
  data() {
    return {
      preLookModal: false,
      codeUrl: '', // 二维码图片
      qrcodeUrl: '', // 生成二维码地址
      copyUrl: '', // 短链接
      copyLongUrl: '', // 长链接
    };
  },
  methods: {
    open(param = {}) {
      getQrcodeInfo(param).then(res => {
        this.preLookModal = true;
        this.qrcodeUrl = res.data.qrCodeLongUrl;
        this.copyUrl = res.data.qrCodeUrl || res.data.qrCodeShortUrl;
        this.copyLongUrl = res.data.qrCodeLongUrl;
        // 把生成的二维码转换成图片
        this.$nextTick(() => {
          const targetId = document.getElementById('target');
          const canvasData = targetId.children[0];
          this.codeUrl = canvasData.toDataURL();
        });
        this.$emit('load-complete', res);
      }).catch(err => {
        this.$Message.warning(err.message);
        this.$emit('load-complete', err);
      });
    },
    copy() {
      copyText(this.copyUrl).then(() => {
        this.$Message.success('复制成功');
      });
    },
    copyLong() {
      copyText(this.copyLongUrl).then(() => {
        this.$Message.success('复制成功');
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@sditest/electronic-invoice-api/src/components/electronicInvoiceApi/viewQrcode.vue